module.exports = __webpack_public_path__ + "img/1534503486.516aaa08.jpg";